import type { DashboardFeatureConfig } from '../../../types/features/DashboardFeatureConfig';

export const dashboard: DashboardFeatureConfig = {
    showOutstandingPremiumButton: false,
};
